import { orderedListSlide } from './SLSprint00'
import { checklistAnnouncementsPreworkAndAgenda } from './SL00000Sprint00'
import { tPrework } from './SLSprint00'
import { completeDeck } from './SL00000Sprint00'
import { list44000Sprint08 } from '../ActivityLists/AL44000Sprint08'

// Software Engineering (SE) sprint 8 global values.
const sprint = 8
const activityList = () => { return list44000Sprint08(sprint) }

// Final Exam / Final Project Presentation
const se_8_7of6_PAaA = {
	'announcements':[ 
		'Class Product Presentations',
		'Please consider taking time to complete your course evaluation' ],
	'prework':[
		'Be prepared for your final project presentations' ],
	'agenda':[
		'Product Overview',
		'Individual Class Product Presentations',
		'Thank you!' ] 
}
export const se_8_7of6 = () => { 
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_8_7of6_PAaA, sprint, activityList)
	const productPresentation = () => {
		return orderedListSlide(
			'Class Product Presentations', 
			`Product Overview (less than 5 minutes) followed by each team member providing a:`, [
			'Demonstration of product functionality that they are particularly proud of personally delivering running in the production environment',
			'Description of how the functionality benefits customers / users',
			'Review of the related source code',
			'Review of a User Story from a sprint backlog that the presenter completed as part of delivering the functionality' ])
	}

	const nextSteps = () => { return tPrework('Next Steps', [ 'Everything is due Wednesday!' ], sprint, activityList) }
	const finalComments = () => {
		return orderedListSlide('Thank you!', '', [
			'Thank you for making this a wonderful experience for me',
			'Don’t hesitate to reach out in the future',
			'Hope to see you in a future class', 
			'Reach out to me if you are interested in taking Web & Distributed Programming',
			'Very nice work! I am impressed with what you have accomplished.' ])
	}

	return completeDeck(slideDeck, [ productPresentation, nextSteps, finalComments ]) 
}